(function () {
  // Map Klaviyo form IDs to discount codes.
  // Any form not listed here gets DEFAULT_CODE.
  var FORMS = [
    { id: 'TpjqE4', code: 'WELCOMEBACK5' },
  ];
  var DEFAULT_CODE = 'WELCOME10';

  function applyDiscount(code, source) {
    if (!code) return;
    console.log('[klaviyo-discount] applying ' + code + ' via ' + source);

    if (typeof window.leviveApplyDiscount === 'function') {
      window.leviveApplyDiscount(code);
    } else {
      fetch('/discount/' + encodeURIComponent(code) + '?redirect=/', { credentials: 'same-origin' })
        .then(function () {
          if (typeof window.leviveRefreshCart === 'function') {
            window.leviveRefreshCart();
          }
        })
        .catch(function (err) { console.error('[klaviyo-discount] failed:', err); });
    }
  }

  function codeFromBody(bodyStr) {
    if (typeof bodyStr === 'string') {
      for (var i = 0; i < FORMS.length; i++) {
        if (bodyStr.indexOf(FORMS[i].id) !== -1) return FORMS[i].code;
      }
    }
    return DEFAULT_CODE;
  }

  function isKlaviyoSubscription(method, url) {
    return (
      method === 'POST' &&
      typeof url === 'string' &&
      (url.indexOf('/client/subscriptions') !== -1 ||
       url.indexOf('/ajax/subscriptions') !== -1)
    );
  }

  // Method 1: klaviyoForms event (fires on some Klaviyo setups)
  document.addEventListener('klaviyoForms', function (e) {
    var d = (e && e.detail) || {};
    if (d.type === 'submit' || d.type === 'stepChange') {
      var formId = d.formId || d.form_id || '';
      var code = DEFAULT_CODE;
      for (var i = 0; i < FORMS.length; i++) {
        if (FORMS[i].id === formId) { code = FORMS[i].code; break; }
      }
      applyDiscount(code, 'klaviyoForms:' + d.type);
    }
  });

  // Method 2: XHR interception — intercept both open (to flag klaviyo calls)
  // and send (to read the body and identify which form was submitted)
  var origXHROpen = XMLHttpRequest.prototype.open;
  var origXHRSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    if (isKlaviyoSubscription(method && method.toUpperCase(), url)) {
      this._leviveKlaviyoSub = true;
    }
    return origXHROpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function (body) {
    if (this._leviveKlaviyoSub) {
      var bodyStr = typeof body === 'string' ? body : (body ? JSON.stringify(body) : '');
      var code = codeFromBody(bodyStr);
      var xhr = this;
      xhr.addEventListener('load', function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          console.log('[klaviyo-discount] subscription XHR success');
          applyDiscount(code, 'xhr');
        }
      });
    }
    return origXHRSend.apply(this, arguments);
  };

  // Method 3: fetch interception — body is available upfront
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var method = (init && init.method && init.method.toUpperCase()) || 'GET';
    if (isKlaviyoSubscription(method, url)) {
      var bodyStr = (init && typeof init.body === 'string') ? init.body : '';
      var code = codeFromBody(bodyStr);
      return origFetch.call(window, input, init).then(function (response) {
        if (response.ok) {
          console.log('[klaviyo-discount] subscription fetch success');
          applyDiscount(code, 'fetch');
        }
        return response;
      }, function (err) { throw err; });
    }
    return origFetch.call(window, input, init);
  };
})();
